module.exports = __webpack_public_path__ + "img/menu.68dc3d68.svg";